import React from 'react';
import { Accordion } from '@naf-simba/elements-accordion';
import { useLocation } from 'react-router';
import { AccordionListBlockType } from '@appTypes/AccordionListBlockType';
import { NAFGTMEvent } from '@appTypes/GTM/NAFGTMEvent';
import { EventPayload } from '@appTypes/GTM/EventPayload';
import { useGTMDataLayer } from '@hooks/GTM/useGTMDataLayer';
import useSelector from '@redux/typedHooks';
import BlockContent from '@components/block-content/BlockContent';

interface AccordionListBlockProps {
  block: AccordionListBlockType;
}

export const AccordionListBlock = ({ block }: AccordionListBlockProps) => {
  const location = useLocation();
  const dataLayer = useGTMDataLayer();
  const baseUrl = useSelector((state) => state.application.baseUrl);

  const onOpen = (accordionTitle: string) => {
    if (dataLayer) {
      const eventPayload: EventPayload = {
        event: NAFGTMEvent.accordionOpen,
        listValue: `${accordionTitle}`,
        page: location.pathname,
        pageUrl: `${baseUrl}${location.pathname}`,
      };
      dataLayer.push(eventPayload);
    }
  };

  return (
    <>
      {block.accordionList.map((item) => (
        <Accordion
          headingLevel={3}
          key={item._key}
          title={item.title}
          onChange={({ value }) => value && onOpen(item.title)}
        >
          <BlockContent value={item.content} />
        </Accordion>
      ))}
    </>
  );
};
